
/* ============================== src/utils/reactions.js ============================== */
// src/utils/reactions.js

/**
 * Единственный источник правды о доступных реакциях: emoji (символ для
 * хранения в данных), unified (id для отрисовки спрайта через <Emoji>
 * из emoji-picker-react) и label (title/aria-label).
 */
export const REACTIONS = [
  { emoji: "👍", unified: "1f44d", label: "Ок" },
  { emoji: "❤️", unified: "2764-fe0f", label: "Нравится" },
  { emoji: "🔥", unified: "1f525", label: "Огонь" },
  { emoji: "✅", unified: "2705", label: "Принято" },
  { emoji: "👀", unified: "1f440", label: "Смотрю" },
  { emoji: "🐞", unified: "1f41e", label: "Ошибка" },
  { emoji: "💡", unified: "1f4a1", label: "Идея" },
  { emoji: "🤔", unified: "1f914", label: "Думаю" },
  { emoji: "🎉", unified: "1f389", label: "Ура" },
  { emoji: "✈️", unified: "2708-fe0f", label: "Взлетаем" },
];

const ALLOWED = new Set(REACTIONS.map((r) => r.emoji));
const UNIFIED_BY_EMOJI = new Map(REACTIONS.map((r) => [r.emoji, r.unified]));

/** Предикат для домена: можно ли вообще такую реакцию поставить. */
export const isAllowedReaction = (emoji) => ALLOWED.has(emoji);

/** Символ → unified id. Для эмодзи, которых нет в списке, - null. */
export const unifiedOf = (emoji) => UNIFIED_BY_EMOJI.get(emoji) || null;
